import { gql } from "@apollo/client";

export const GET_INSTITUCIONES_SAP = gql`
    query QGetInstitucionesSAP($idDelegacion: Int!){
        institucionesSAP(idDelegacion: $idDelegacion) {
            success,
            error,
            valorEsperado {
              cod_Institucion,
              nombre,
              provincia,
              localidad,
              cUIT,
              domicilio,
              idProvincia,
              idDelegacion,
              delegacion
            }
          }
    }`;